import { render } from "./transfersDeparturesOrderList.vue?vue&type=template&id=dda4a4d6"
import script from "./transfersDeparturesOrderList.vue?vue&type=script&lang=js"
export * from "./transfersDeparturesOrderList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__